<template>
    <div>
        <el-form
                ref="ruleForm"
                style="position: relative"
                label-width="130px"
                :model="form"
                :rules="rules">
            <el-form-item label="生成账号个数：" prop="num">
                <el-input v-model="form.num" type="number" style="width: 270px" placeholder="请输入账号个数1-1000"></el-input>
            </el-form-item>
            <el-form-item label="密码设置：" prop="password">
                <el-input v-model="form.password" style="width: 270px" placeholder="请输入密码，默认123456"></el-input>
            </el-form-item>
            <el-form-item class="form-item-btn" label-width="0">
                <el-button style="width: 200px" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <p>注：生成成功后，将生成记录并提供下载链接，请耐心等候</p>
            </el-form-item>
        </el-form>
        <strong>历史记录</strong>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="autoCreateUserList.beanList"
                    row-key="id"
                    height="100%">
                <el-table-column type="index" align="center" label="编号"/>
                <el-table-column align="center" min-width="150" label="目标生成个数" prop="targetNumber"/>
                <el-table-column align="center" min-width="150" label="实际生成个数" prop="actualNumber"/>
                <el-table-column align="center" label="密码设置" prop="password"/>
                <el-table-column align="center" label="状态">
                    <template slot-scope="scope">{{scope.row.status | statusName}}</template>
                </el-table-column>
                <el-table-column align="center" min-width="150" label="提交时间" prop="submitTime"/>
                <el-table-column align="center" min-width="150" label="生成时间" prop="finishTime"/>
                <el-table-column align="center" width="150" label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status === 2" size="mini" type="primary"
                                   @click="exportFunc(scope.row.id)">下载
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :pager-count="5"
                :page-size="20"
                :total="autoCreateUserList.total"
                @current-change="getList($event)"
                :page-count="currentPage"/>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                form: {
                    num: '',
                    password: ''
                },
                rules: {
                    num: [
                        {required: true, message: '请输入账号个数', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                if (value > 1000 || value < 1 || value % 1 !== 0) {
                                    callback(new Error('请输入1-1000'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ]
                },
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('user', ['autoCreateUserList'])
        },
        created() {
            this.getList()
        },
        filters: {
            statusName(type) {
                let arr = ['等待处理', '处理中', '完成', '任务失败'];
                return arr[type]
            }
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('user', ['createUsers', 'getAutoCreateUserList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getAutoCreateUserList({
                    page
                }).then(() => {
                    this.loading = false;
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$confirm('生成账号需要一定时间（大约2分钟），请耐心等候，等候期间可以离开进行其他操作，不影响账号生成。', '温馨提示', {
                            type: 'info'
                        }).then(() => {
                            this.createUsers(this.form).then(() => {
                                this.$message.success('提交成功');
                                this.$refs[formName].resetFields();
                                this.getList(this.currentPage);
                            })
                        }).catch(() => {
                        })
                    }
                })
            },
            exportFunc(id) {
                this.setStateDownloadConfig({
                    action: '/usermemger/autoCreateUser/export',
                    info: [
                        {name: 'taskId', value: id},
                    ]
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .form-item-btn {
        position: absolute;
        top: 30px;
        left: 430px;
    }
</style>